const localStore = {
    saveLocalStorage(KEY,data) {
        localStorage.setItem(KEY,data)
    },
    getLocalStorage(KEY) {
        return localStorage.getItem(KEY)
    }
}

export { localStore }